// Minimal i18n module — scales to all 5 languages, falls back to English
// Layer 1 (AI replies in chosen language) is already complete via backend.
// This Layer 2 covers high-traffic UI strings.

const STRINGS = {
  english: {
    welcome: "Welcome", moneyPulse: "Here's your money pulse",
    cashPosition: "Estimated cash position", owedToYou: "Owed to you", activeDebtors: "Active debtors",
    today: "Today", week: "Week", month: "Month",
    sales: "Sales", expenses: "Expenses", net: "Net", paymentsIn: "Payments in",
    last7Days: "Last 7 days", salesVsExpenses: "Sales vs expenses",
    recentActivity: "Recent activity", entries: "entries",
    chatPlaceholder: "Type, talk, or snap →", getPaid: "Get paid",
    debtorsTitle: "Debtors", debtorsSubtitle: "Money owed to you",
    inventoryTitle: "Inventory", stockTitle: "Your stock",
    loansTitle: "Kobolog Cash", loansSubtitle: "Working capital, fast",
    profileTitle: "Profile", signOut: "Sign out",
    // New keys
    totalOutstanding: "Total outstanding",
    debtorsCount: "Debtors", remind: "Remind", markPaid: "Mark paid",
    everyonePaid: "Everyone's paid up!", noOneOwes: "No one owes you. Beautiful.",
    unpaidItem: "unpaid item", unpaidItems: "unpaid items",
    addBtn: "Add", restockTime: "Time to restock", lowStock: "Low stock",
    noStockYet: "No stock yet", noStockHint: "Add items manually or just chat: \"Added 20 cartons of noodles to stock\"",
    addProduct: "Add product", productName: "Name", unit: "Unit", stockQty: "Stock",
    sellPrice: "Sell price (₦)", restockAt: "Restock at",
    weeklyReport: "Weekly Report", monthlyReport: "Monthly Report",
    whatsappShare: "WhatsApp", saveImg: "Save", shareDiary: "Share",
    phone: "Phone", businessType: "Business type", location: "Location", memberSince: "Member since", language: "Language", change: "Change",
    chooseLanguage: "Choose your language", loadDemo: "Load demo data again",
    manageSubscription: "Manage subscription", upgradeToPro: "Upgrade to Pro · ₦1,500/mo",
    workingCapital: "Loans based on your real cashflow, not collateral.",
    almostThere: "Almost there!",
    interest: "Interest", term: "Term", dailyRepay: "Daily repay",
    acceptCash: "Accept & get cash",
    loadingNumbers: "Loading your numbers...", loadingDebtors: "Loading debtors...",
    loadingInventory: "Loading inventory...", checkingOffer: "Checking your offer...",
    goodsOnCredit: "Goods on credit", due: "Due", logged: "Logged",
    noTxYet: "No transactions yet. Send your first message in chat!",
  },
  pidgin: {
    welcome: "How far", moneyPulse: "Na your money status be this",
    cashPosition: "Cash wey you get", owedToYou: "People owe you", activeDebtors: "People wey never pay",
    today: "Today", week: "This week", month: "This month",
    sales: "Wetin you sell", expenses: "Wetin you spend", net: "Wetin you gain", paymentsIn: "Money wey enter",
    last7Days: "Last 7 days", salesVsExpenses: "Wetin you sell vs spend",
    recentActivity: "Recent gist", entries: "entries",
    chatPlaceholder: "Yarn me, voice note, or snap pic →", getPaid: "Collect money",
    debtorsTitle: "People wey owe", debtorsSubtitle: "People wey neva pay you",
    inventoryTitle: "Your goods", stockTitle: "Wetin you get",
    loansTitle: "Kobolog Cash", loansSubtitle: "Working capital sharp sharp",
    profileTitle: "My account", signOut: "Comot",
    totalOutstanding: "Total wey dem owe",
    debtorsCount: "Customers", remind: "Remind am", markPaid: "Don pay",
    everyonePaid: "Everybody don pay! 🎉", noOneOwes: "Nobody owe you. Sweet.",
    unpaidItem: "thing wey neva pay", unpaidItems: "things wey neva pay",
    addBtn: "Add", restockTime: "Time to restock", lowStock: "Stock dey finish",
    noStockYet: "No goods yet", noStockHint: "Add by hand or yarn me: \"I add 20 cartons of noodles\"",
    addProduct: "Add goods", productName: "Name", unit: "Unit", stockQty: "Stock",
    sellPrice: "Sell price (₦)", restockAt: "Restock when am reach",
    weeklyReport: "Weekly Report", monthlyReport: "Monthly Report",
    whatsappShare: "WhatsApp", saveImg: "Save", shareDiary: "Share am",
    phone: "Phone", businessType: "Wetin you dey sell", location: "Where you dey", memberSince: "Since when", language: "Language", change: "Change am",
    chooseLanguage: "Pick your language", loadDemo: "Load demo data again",
    manageSubscription: "Manage subscription", upgradeToPro: "Upgrade to Pro · ₦1,500/mo",
    workingCapital: "Loan wey base on your real sales, no collateral.",
    almostThere: "You don near reach!",
    interest: "Interest", term: "Term", dailyRepay: "Daily pay",
    acceptCash: "Accept & collect cash",
    loadingNumbers: "Dey load your numbers...", loadingDebtors: "Dey load debtors...",
    loadingInventory: "Dey load inventory...", checkingOffer: "Dey check your offer...",
    goodsOnCredit: "Goods on credit", due: "Suppose pay", logged: "Logged",
    noTxYet: "No transaction yet. Yarn me wetin happen today!",
  },
  yoruba: {
    welcome: "Káàbọ̀", moneyPulse: "Ìyẹ owó rẹ nìyí",
    cashPosition: "Owo tó kù", owedToYou: "Owó tí wọ́n jẹ ọ", activeDebtors: "Àwọn tó jẹ ọ",
    today: "Òní", week: "Ọsẹ̀ yìí", month: "Oṣù yìí",
    sales: "Títà", expenses: "Inawo", net: "Èrè", paymentsIn: "Owó tó wọlé",
    last7Days: "Ọjọ́ méje sẹ́yìn", salesVsExpenses: "Títà àti inawo",
    recentActivity: "Ohun tó ṣẹ̀ṣẹ̀", entries: "àkọsílẹ̀",
    chatPlaceholder: "Sọ̀rọ̀, voice note, tàbí ya foto →", getPaid: "Gba owó",
    debtorsTitle: "Àwọn tó jẹ ọ", debtorsSubtitle: "Àwọn tí kò tíì san",
    inventoryTitle: "Ọjà rẹ", stockTitle: "Ọjà tó kù",
    loansTitle: "Kobolog Cash", loansSubtitle: "Owó owó-òṣèlú kíákíá",
    profileTitle: "Àkọọ́lẹ̀ mi", signOut: "Jáde",
    totalOutstanding: "Lapapọ̀ tí wọ́n jẹ",
    debtorsCount: "Onibàárà", remind: "Ránti rẹ", markPaid: "Sàmì sí gẹ́gẹ́ bí o ti san",
    everyonePaid: "Gbogbo wọn ti san! 🎉", noOneOwes: "Kò sí ẹni tó jẹ ọ. Dáadáa.",
    unpaidItem: "ohun tí kò san", unpaidItems: "ohun tí kò san",
    addBtn: "Fi kún", restockTime: "Ìgbà láti tún ra ọjà", lowStock: "Ọjà ń tán",
    noStockYet: "Kò sí ọjà síbẹ", noStockHint: "Fi kún tàbí kàn sọ pé: \"Mo ra ìpàrọ́ 20\"",
    addProduct: "Fi ọjà kún", productName: "Orúkọ", unit: "Ẹ̀ka", stockQty: "Ọjà",
    sellPrice: "Iye títà (₦)", restockAt: "Tún ra nígbà tó kù",
    weeklyReport: "Ìròyìn ọsẹ̀", monthlyReport: "Ìròyìn oṣù",
    whatsappShare: "WhatsApp", saveImg: "Fi pamọ́", shareDiary: "Pín",
    phone: "Tẹlifóònù", businessType: "Iru iṣẹ́", location: "Ibìtí o wà", memberSince: "Láti", language: "Èdè", change: "Yí padà",
    chooseLanguage: "Yan èdè rẹ", loadDemo: "Tún data ìfihàn ránpọ̀",
    manageSubscription: "Ṣàkóso ìforúkọsílẹ̀", upgradeToPro: "Yí sí Pro · ₦1,500/oṣù",
    workingCapital: "Awin tó dá lórí ìtà rẹ, kì í ṣe gàárì.",
    almostThere: "O ti súnmọ́!",
    interest: "Ìfọ̀wọ́sí", term: "Ìgbà", dailyRepay: "Ìsanwó ojoojúmọ́",
    acceptCash: "Gba owó",
    loadingNumbers: "Ń ṣe àwọn nọ́mbà rẹ...", loadingDebtors: "Ń ṣe àwọn ajigbe...",
    loadingInventory: "Ń ṣe ọjà...", checkingOffer: "Ń ṣayẹ̀wò àfojúsùn...",
    goodsOnCredit: "Ọjà lórí kíríìdìtì", due: "Ọjọ́ ìsanwó", logged: "Tà",
    noTxYet: "Kò sí àkọsílẹ̀ síbẹ. Fi ìfiránṣẹ́ àkọkọ́ ránṣẹ́!",
  },
  hausa: {
    welcome: "Sannu", moneyPulse: "Ga halin kuɗin ka",
    cashPosition: "Kuɗin da ke hannunka", owedToYou: "Kuɗin da ake bin ka", activeDebtors: "Masu ci bashi",
    today: "Yau", week: "Mako", month: "Wata",
    sales: "Siyarwa", expenses: "Kashe-kashe", net: "Riba", paymentsIn: "Kuɗin shiga",
    last7Days: "Kwanaki 7 da suka wuce", salesVsExpenses: "Siyarwa da kashe-kashe",
    recentActivity: "Sabbin abubuwa", entries: "rikodi",
    chatPlaceholder: "Rubuta, magana, ko ɗauki hoto →", getPaid: "Karɓi kuɗi",
    debtorsTitle: "Masu ci bashi", debtorsSubtitle: "Wadanda ba su biya ba tukuna",
    inventoryTitle: "Kayan ka", stockTitle: "Abin da ka ke da shi",
    loansTitle: "Kobolog Cash", loansSubtitle: "Babban birni cikin sauri",
    profileTitle: "Asusuna", signOut: "Fita",
    totalOutstanding: "Jimillar bashin",
    debtorsCount: "Masu bashi", remind: "Tunatar", markPaid: "Ya biya",
    everyonePaid: "Kowa ya biya! 🎉", noOneOwes: "Ba wanda ke binka bashi. Da kyau.",
    unpaidItem: "abin da ba a biya", unpaidItems: "abubuwan da ba a biya",
    addBtn: "Ƙara", restockTime: "Lokacin sake kawo", lowStock: "Stock yana ƙarewa",
    noStockYet: "Babu kayan har yanzu", noStockHint: "Ƙara da hannu ko ka faɗa: \"Na ƙara taya 20\"",
    addProduct: "Ƙara kaya", productName: "Suna", unit: "Naúrar", stockQty: "Stock",
    sellPrice: "Farashin sayarwa (₦)", restockAt: "Sake kawo lokacin",
    weeklyReport: "Rahoton mako", monthlyReport: "Rahoton wata",
    whatsappShare: "WhatsApp", saveImg: "Ajiye", shareDiary: "Raba",
    phone: "Waya", businessType: "Nau'in kasuwanci", location: "Wuri", memberSince: "Tun", language: "Yare", change: "Canza",
    chooseLanguage: "Zaɓi yarenka", loadDemo: "Sake loda bayanan demo",
    manageSubscription: "Sarrafa biyan kuɗi", upgradeToPro: "Haɓaka zuwa Pro · ₦1,500/wata",
    workingCapital: "Lamuni dangane da kuɗin shiga na gaske, ba jingina ba.",
    almostThere: "Kusan ka cika!",
    interest: "Riba", term: "Zango", dailyRepay: "Biyan kullum",
    acceptCash: "Karɓa & sami kuɗi",
    loadingNumbers: "Ana loda lambobinka...", loadingDebtors: "Ana loda masu bashi...",
    loadingInventory: "Ana loda kaya...", checkingOffer: "Ana duba tayinka...",
    goodsOnCredit: "Kaya akan bashi", due: "Lokacin biya", logged: "An rikoda",
    noTxYet: "Babu rikodi tukuna. Aika sako na farko a tattaunawa!",
  },
  igbo: {
    welcome: "Nnọọ", moneyPulse: "Lee ọnọdụ ego gị",
    cashPosition: "Ego ị nwere ugbu a", owedToYou: "Ego e ji gị", activeDebtors: "Ndị ji gị ego",
    today: "Taa", week: "Izu a", month: "Ọnwa a",
    sales: "Ire ahịa", expenses: "Mmefu", net: "Uru", paymentsIn: "Ego batara",
    last7Days: "Ụbọchị 7 gara aga", salesVsExpenses: "Ire ahịa vs Mmefu",
    recentActivity: "Ihe na-eme ọhụrụ", entries: "ndekọ",
    chatPlaceholder: "Dee, kwuo okwu, ma ọ bụ sere foto →", getPaid: "Nata ego",
    debtorsTitle: "Ndị ji gị ego", debtorsSubtitle: "Ndị na-akwụbeghị",
    inventoryTitle: "Ngwa ahịa gị", stockTitle: "Ihe ị nwere",
    loansTitle: "Kobolog Cash", loansSubtitle: "Ego ọrụ ngwa ngwa",
    profileTitle: "Akaụntụ m", signOut: "Pụọ",
    totalOutstanding: "Mkpokọta a ji gị",
    debtorsCount: "Ndị na-azụ", remind: "Chetara", markPaid: "Akwụọla",
    everyonePaid: "Onye ọ bụla akwụọla! 🎉", noOneOwes: "Ọ dịghị onye ji gị. Ọ dị mma.",
    unpaidItem: "ihe a na-akwụbeghị", unpaidItems: "ihe ndị a na-akwụbeghị",
    addBtn: "Tinye", restockTime: "Oge ịzụnye ọzọ", lowStock: "Ngwa ahịa na-agwụ",
    noStockYet: "Enwebeghị ngwa ahịa", noStockHint: "Tinye n'aka ma ọ bụ kwuo: \"Atunyere m kọtin 20\"",
    addProduct: "Tinye ngwa", productName: "Aha", unit: "Otu", stockQty: "Ngwa ahịa",
    sellPrice: "Ọnụ ahịa ire (₦)", restockAt: "Zụnye ọzọ mgbe ọ ruru",
    weeklyReport: "Akụkọ izu", monthlyReport: "Akụkọ ọnwa",
    whatsappShare: "WhatsApp", saveImg: "Chekwaa", shareDiary: "Kekọrịta",
    phone: "Ekwentị", businessType: "Ụdị azụmaahịa", location: "Ebe", memberSince: "Site na", language: "Asụsụ", change: "Gbanwee",
    chooseLanguage: "Họrọ asụsụ gị", loadDemo: "Bulite data nlere ọzọ",
    manageSubscription: "Jikwaa ndebanye aha", upgradeToPro: "Bulite na Pro · ₦1,500/ọnwa",
    workingCapital: "Mbinye ego dabere na ego ire ahịa gị, ọ bụghị ihe nrachi.",
    almostThere: "Ị nọ nso!",
    interest: "Ọmụrụnwa", term: "Oge", dailyRepay: "Ụgwọ kwa ụbọchị",
    acceptCash: "Nabata & nweta ego",
    loadingNumbers: "Na-ebu nọmba gị...", loadingDebtors: "Na-ebu ndị ji gị...",
    loadingInventory: "Na-ebu ngwa ahịa...", checkingOffer: "Na-elele onyinye gị...",
    goodsOnCredit: "Ngwa ahịa na kredit", due: "Ụbọchị ịkwụ", logged: "Edenyere",
    noTxYet: "Enwebeghị ndekọ. Zipu ozi mbụ gị!",
  },
};

export function getString(key, lang = "english") {
  const dict = STRINGS[lang] || STRINGS.english;
  return dict[key] || STRINGS.english[key] || key;
}

export function useT(language) {
  const lang = language || "english";
  return (key) => getString(key, lang);
}
